/* eslint-disable @typescript-eslint/no-empty-function */
import React, { FC } from 'react';
import { iconSize } from '../../../../../constants/icon.constants';
import ctaTypes from '../../../../../enums/CTA.enums';
import DictionaryTerm from '../../../dictionaryTerm';
import Icon from '../../../icon';
import './styles.scss';

export type TSearchBoxProps = Partial<{
  handleSearchSubmit: React.DOMAttributes<HTMLFormElement>['onSubmit'];
  handleChange: React.InputHTMLAttributes<HTMLInputElement>['onChange'];
  searchedTerm: string;
  filterdCards: {
    id?: number | string;
    title?: string;
  }[];
  handleSuggestionClick: (title?: string, id?: string | number) => void;
  handleClearSearch: () => void;
  titleDictionaryTerm: string;
  ctaDictionaryTerm: string;
  extraClassName: string;
}>;

const SearchBox: FC<TSearchBoxProps> = ({
  searchedTerm = '',
  filterdCards = [],
  handleSearchSubmit = () => { },
  handleChange = () => { },
  handleSuggestionClick = () => { },
  handleClearSearch,
  titleDictionaryTerm = '',
  ctaDictionaryTerm = '',
  extraClassName = '',
}) => {
  return (
    <form className={`filter-search ${extraClassName}`} onSubmit={handleSearchSubmit}>
      <div className="filter-search__input-wrapper">
        <Icon
          size={iconSize['dsk']}
          iconName="action-search"
          extraClassName="filter-search__search-icon"
        />
        <input value={searchedTerm} className="filter-search__input" onChange={handleChange} />
        <span className="filter-search__placeholder">
          <DictionaryTerm keyword={titleDictionaryTerm} />
        </span>
        {handleClearSearch && (
          <div className="filter-search__close-icon-wrapper">
            <Icon
              size={iconSize['dsk']}
              iconName="action-close"
              extraClassName="filter-search__close-icon"
              onClick={handleClearSearch}
            />
          </div>
        )}
        {filterdCards?.length > 0 && (
          <div className="filter-search__suggestion">
            {filterdCards?.map(({ title, id }) => (
              <div
                className="filter-search__suggestion-item"
                key={id}
                onClick={() => handleSuggestionClick(title, id)}
              >
                {title}
              </div>
            ))}
          </div>
        )}
      </div>
      <button
        type="submit"
        disabled={searchedTerm?.length < 1}
        className={`button ${ctaTypes['primaryOrange']} filter-search__cta ${searchedTerm?.length < 1 ? 'filter-search__cta--disabled' : ''
          }`}
      >
        <DictionaryTerm keyword={ctaDictionaryTerm} />
      </button>
    </form>
  );
};

export default SearchBox;
